export class ReportRequest {
  startDate?: string; // LocalDateTime → ISO string
  endDate?: string;
  pumpId?: number;
  nozzleId?: number;
  fuelId?: number;
  format?: string;

  constructor(init?: Partial<ReportRequest>) {
    Object.assign(this, init);
  }

  // Getters & Setters
  getStartDate(): string | undefined {
    return this.startDate;
  }
  setStartDate(value: string | undefined): void {
    this.startDate = value;
  }

  getEndDate(): string | undefined {
    return this.endDate;
  }
  setEndDate(value: string | undefined): void {
    this.endDate = value;
  }

  getPumpId(): number | undefined {
    return this.pumpId;
  }
  setPumpId(value: number | undefined): void {
    this.pumpId = value;
  }

  getNozzleId(): number | undefined {
    return this.nozzleId;
  }
  setNozzleId(value: number | undefined): void {
    this.nozzleId = value;
  }

  getFuelId(): number | undefined {
    return this.fuelId;
  }
  setFuelId(value: number | undefined): void {
    this.fuelId = value;
  }

  getFormat(): string | undefined {
    return this.format;
  }
  setFormat(value: string | undefined): void {
    this.format = value;
  }
}
